import { PENDING_RESPONSE_ID_PREFIX } from './message-utils';

import type { ChatMessage, ResumableStreamingResponse } from '../types';

export const findStreamingMessage = (
  messages: ChatMessage[],
  responseId?: string,
): ChatMessage | null => {
  if (responseId) {
    const exactMatch = messages.find((msg) => msg.id === responseId);
    if (exactMatch) {
      return exactMatch;
    }
  }

  const pendingMessages = messages.filter((msg) => msg.id.startsWith(PENDING_RESPONSE_ID_PREFIX));

  return pendingMessages[pendingMessages.length - 1] || null;
};

export const updateMessageById = (
  messages: ChatMessage[],
  messageId: string,
  updates: Partial<ChatMessage>,
): ChatMessage[] => {
  return messages.map((msg) => {
    if (msg.id === messageId) {
      return { ...msg, ...updates };
    }
    return msg;
  });
};

export const removeMessagesByPredicate = (
  messages: ChatMessage[],
  predicate: (msg: ChatMessage) => boolean,
): ChatMessage[] => {
  return messages.filter((msg) => !predicate(msg));
};

export const isPendingResponseMessage = (message: ChatMessage): boolean => {
  return message.id.startsWith(PENDING_RESPONSE_ID_PREFIX);
};

export const isResumableStreamingResponse = (
  message: ChatMessage | null | undefined,
): message is ResumableStreamingResponse =>
  message != null &&
  message.type === 'response' &&
  message.isStreaming === true &&
  typeof message.lastChunkNumber === 'number';
